import * as React from "react";
const SvgFiRrBoxFragile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-box-fragile_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM17 6v4a5.01 5.01 0 0 1-4 4.899V18h2a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2h2v-3.101c-2.338-.484-4-2.683-4-5.122V6a2 2 0 0 1 2-2h1.783S9.094 6.838 9.07 6.917a1.62 1.62 0 0 0 .249 1.43c.304.409.788.653 1.297.653h2.068l-1.533 2.473a1 1 0 0 0 1.7 1.054l1.881-3.037a1.6 1.6 0 0 0 .077-1.645 1.6 1.6 0 0 0-1.413-.846h-2.079l1.798-3H15A2 2 0 0 1 17 6"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-box-fragile_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBoxFragile;
